// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/intereses/list',
    name: 'intereses-hotels-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/Intereses.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_intereses_hotels',
    },
  },
]

export default formTable
